import { Check } from 'lucide-react';
import React from 'react';

export const PricingTierFeature: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className='flex items-center'>
      <Check className='mr-2 size-4 text-primary' />
      {children}
    </div>
  );
};
